import React from 'react';
import { useNavigate } from 'react-router-dom';
import GoogleImg from '../../assets/images/not_found.svg';
// import { useIsLoggedInQuery } from '../../redux/apis/authApi';
import { GLOBAL } from '../../utils/constant/global';

const {
  BACK_HOME,
  CONTENT
  //PAGE_NOT_FOUND
} = GLOBAL;

const Page404 = () => {
  //const { data } = useIsLoggedInQuery();
  const navigate = useNavigate();

  const handleBackHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="page-404 d-flex justify-content-center align-items-center vh-100 bg-dark text-light">
      <div
        className="text-center card border-0 bg-dark shadow-lg p-4 p-md-5"
        style={{ maxWidth: '400px' }}
      >
        <div>
          <img src={GoogleImg} alt="404 Not Found" className="img-fluid w-75 mb-4" />
        </div>
        <p className="lead mb-4">
          {CONTENT || 'Oops! The page you are looking for does not exist.'}
        </p>
        <button onClick={handleBackHome} className="btn btn-lg btn-light lift text-uppercase px-4">
          {BACK_HOME || 'Back to Home'}
        </button>
      </div>
    </div>
  );
};

export default Page404;
